<template>
<!-- Make a div wrapped slider,set height and width -->
    <div>
      <!-- Using the slider component -->
        <slider ref="slider" :options="options">
            <!-- slideritem wrapped package with the components you need -->
            <slideritem v-for="(item,index) in slides" :key="index" :style="item.style">
                <a :href="item.url_link !== null ? item.url_link : ''" :target="item.url_link !== null ? '_blank' : ''">
                    <img :src="`${item.path}`">
                </a>
            </slideritem>
        </slider>
    </div>
</template>
<script>

    import { slider, slideritem } from 'vue-concise-slider'
    export default {
        props:['slides'],
        data () {
            return {
                options: {
                    currentPage: 0,
                    loop: true,
                    speed: 600,
                    loopedSlides:1,
                    autoplay:'3000',
                    slidesToScroll:1
                }
            }
        },
        components: {
            slider,
            slideritem
        }
    }
</script>
